async function loginWithGoogle(urls, Network) {
  const url = urls.loginWithGoogle + window.location.origin
  const response = await sendRequest(url, Network)
  const parsedResponse = parseResponse(response, Network)
  return parsedResponse
}

async function sendRequest(url, Network) {
  const response = await Network.sendGetRequest(url)
  return response
}

function parseResponse(response, Network) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    return {
      success: true,
      redirectUrl: response.response.data,
    }
  }
  if (response.status.code === 404) {
    return {
      success: false,
      messageId: 'messages.loginWithGoogle.userNotFound',
    }
  }
  if (response.status.code === 401) {
    return {
      success: false,
      messageId: 'messages.loginWithGoogle.badPassword',
    }
  }
  return Network.defaultResponseParsing(response)
}

export { loginWithGoogle }
